module.exports = (idSuffix) => [
  {
    "idAgent":"0d724c3ab9",
    "agentNameFirst":"Jane",
    "agentNameLast":"Doe"
  },
  {
    "idAgent":"378b485f08",
    "agentNameFirst":"Benjamin",
    "agentNameLast":"Estin"
  },
  {
    "idAgent":"590a03edb4",
    "agentNameFirst":"John",
    "agentNameLast":"Agent"
  },
  {
    "idAgent":"d671a6cf47",
    "agentNameFirst":"Kim",
    "agentNameLast":"Test"
  },
  {
    "idAgent":"0a3cf24ab9",
    "agentNameFirst":"Matt",
    "agentNameLast":"Test"
  },
  {
    "idAgent":"41100c6f68",
    "agentNameFirst":"Tina",
    "agentNameLast":"Test"
  },
  {
    "idAgent":"a40e680f43",
    "agentNameFirst":"Beth",
    "agentNameLast":"Test"
  },
  {
    "idAgent":"cbf2ef0cae",
    "agentNameFirst":"Cori",
    "agentNameLast":"Test"
  },
  {
    "idAgent":"dfb2cb6b60",
    "agentNameFirst":"Elizabeth",
    "agentNameLast":"Test"
  },
  {
    "idAgent":"a637456c60",
    "agentNameFirst":"Gail",
    "agentNameLast":"Test"
  },
  {
    "idAgent":"c4a3b0032b",
    "agentNameFirst":"John",
    "agentNameLast":"Test"
  },
  {
    "idAgent":"eace50fbd4",
    "agentNameFirst":"Dan",
    "agentNameLast":"Coday"
  },
  {
    "idAgent":"7bf7c6313f",
    "agentNameFirst":"Gretchen",
    "agentNameLast":"Kaufman"
  },
  {
    "idAgent":"4263d9bdb1",
    "agentNameFirst":"James",
    "agentNameLast":"Reilly"
  },
  {
    "idAgent":"8955b9f80f",
    "agentNameFirst":"Tom",
    "agentNameLast":"Whytsell"
  },
  {
    "idAgent":"597347a71b",
    "agentNameFirst":"Lamar",
    "agentNameLast":"Russo"
  },
  {
    "idAgent":"16f4df0e07",
    "agentNameFirst":"Jeremy",
    "agentNameLast":"Beck"
  },
  {
    "idAgent":"c5196b4605",
    "agentNameFirst":"Samantha",
    "agentNameLast":"Seaburn"
  }
].map((agent) => !idSuffix ? agent : ({
    ...agent,
    idAgent: agent.idAgent + idSuffix,
}));
